var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9253 10.8952C28.6857 10.8952 27.9647 10.8931 28.115 10.8989C28.0267 10.5618 27.8512 10.2429 27.5874 9.97913L24.9115 7.30312C24.3332 6.72481 23.4455 6.55669 22.7022 6.88499C22.303 7.06135 21.8274 6.97235 21.5187 6.66363C21.21 6.35498 21.1211 5.87938 21.2973 5.48025C21.6256 4.73711 21.4576 3.84921 20.8792 3.27084L18.2033 0.594831C17.4101 -0.198248 16.1196 -0.198307 15.3264 0.594831L11.9785 3.9428C12.922 4.88706 17.9843 9.95337 18.9253 10.8952Z",
    fill: "#F302CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7304 5.19067L5.026 10.8951H16.4293C16.4086 10.8744 15.9722 10.4375 10.7304 5.19067Z",
    fill: "#F302CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7335 20.3368C29.4911 20.0435 30.0001 19.2967 30.0001 18.4788V14.6944C30.0001 13.5728 29.0875 12.6602 27.9659 12.6602H23.8236V30.0001H27.9659C29.0875 30.0001 30.0001 29.0875 30.0001 27.9658V24.1814C30.0001 23.3635 29.4912 22.6168 28.7336 22.3235C28.3267 22.1658 28.0532 21.7666 28.0532 21.3301C28.0532 20.8935 28.3267 20.4944 28.7335 20.3368Z",
    fill: "#F302CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00012207 14.6944V18.4788C0.00012207 19.2967 0.509127 20.0435 1.26666 20.3367C1.67361 20.4944 1.94697 20.8935 1.94697 21.3301C1.94697 21.7666 1.67355 22.1658 1.26661 22.3235C0.509068 22.6168 0.00012207 23.3635 0.00012207 24.1814V27.9658C0.00012207 29.0875 0.912719 30.0001 2.03438 30.0001H22.0592V12.6602H2.03438C0.912719 12.6602 0.00012207 13.5727 0.00012207 14.6944H0.00012207ZM6.17665 16.7644H19.4121V18.5292H6.17665V16.7644ZM6.17665 20.2939H19.4121V22.0587H6.17665V20.2939ZM6.17665 23.8234H19.4121V25.5882H6.17665V23.8234Z",
    fill: "#F302CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketing);
export default __webpack_public_path__ + "static/media/Ticketing.e7fcd1a400d76359aeea2638bbadebdc.svg";
export { ForwardRef as ReactComponent };